export const genericTrans = " transition-colors duration-100";
export const genericHover = " hover:bg-gray-800 hover:text-white";
export const genericActive = " active:bg-gray-700";

export const hierarchy = " ";
export const hierarchySubDir = " border-l-[16px] border-gray-800";

export const hierarchyItem =
  " flex-row items-center px-2 flex h-7 gap-2.5 text-base text-left focus:bg-gray-800 active:bg-gray-700 truncate" +
  genericHover;
export const hierarchyItemCaret = " relative -left-1 w-1 h-5";
export const hierarchyIcon = " w-5 h-5";
export const hierarchyActive = " block bg bg-slate-800 text-white";

export const tab =
  " text-gray-300 border-b-2 pt-1 h-full flex -mb-[2px] items-center justify-center leading-none border-b px-3 gap-3";
export const tabHover = " text-white hover:border-b-slate-600";
export const tabActive =
  " text-[#97feffff] fill-[#97feffff] border-b-[#97feffff]";
export const tabInactive = " border-b-gray-800 hover:border-b-gray-600";

export const surface = " bg-gray-950 bg-opacity-50";
